export enum AccountTypeEnum {
  SystemAdministrator,
  User
}
